import type { ComponentProps, FC } from "react";

import { EditorButtonBold, EditorButtonItalic, EditorButtonStrike, EditorButtonUnderline } from "../editor-buttons";
import { EditorButtonGroup } from "./editor-button-group";

export const EditorButtonGroupTextMarks: FC<ComponentProps<typeof EditorButtonGroup>> = (props) => (
  <EditorButtonGroup {...props}>
    <EditorButtonBold />
    <EditorButtonItalic />
    <EditorButtonUnderline />
    <EditorButtonStrike />
  </EditorButtonGroup>
);
